<template lang="pug">
//- advrtsmnt--no-detail: таблица ЛК без колонки «Детальная информация» (услуги и
//- магазины) — в ней три текстовые колонки делят ширину поровну, см. ads.scss.
//- Условие требует наличия header: без него это не таблица ЛК, а карточка на
//- странице оплаты, её раскладку не трогаем.
.v-ads.advrtsmnt(v-if="data" :class="{'open': isActionsOpen, 'advrtsmnt--no-detail': data.header && !data.header.detail}")
	.advrtsmnt__inner
		.advrtsmnt__top
			.advrtsmnt__top-wrap
				.advrtsmnt__top-main
					component.advrtsmnt__top-visual(:is="data?.link?.href ? 'a' : 'div'" :href="data?.link?.href || null")
						img.advrtsmnt__top-visual-img(v-if="data.img && data.img.src"
							:src="data.img.src"
							:alt="data.img.alt"
						)
					.advrtsmnt__top-name
						.advrtsmnt__header-info(v-if="showHeaders && data.header && data.header.info") {{data.header.info}}
						.advrtsmnt__top-name-body
							component.advrtsmnt__top-name-text(:is="data?.link?.href ? 'a' : 'span'" :href="data?.link?.href || null" v-if="data.name") {{data.name}}
							.advrtsmnt__top-name-id(v-if="data.id") {{data.prefixId || 'ID'}}:{{data.id}}
							//- Локация «Регион, Район» под ID во всех списках ЛК
							.advrtsmnt__top-name-location(v-if="locationText") {{locationText}}
							//- Цена всегда находится в «Информации»: после локации, если она есть
							.advrtsmnt__top-price(v-if="data.price?.current")
								span.advrtsmnt__top-price-current-currency(v-if="data.price.current.currency") {{data.price.current.currency}}&nbsp
								span.advrtsmnt__top-price-current-value(v-if="data.price.current.value") {{formatInteger(data.price.current.value)}}
			//- Столбцы рисуем по НАЛИЧИЮ ЗАГОЛОВКА (data.header.*), а не по наличию
			//- данных строки: заголовок приходит одинаковым для всех строк списка и
			//- означает «у этой таблицы такой столбец есть». Если вешать v-if на
			//- данные, строка без значения теряет столбец целиком, соседние столбцы
			//- уезжают влево и строка выглядит уже остальных. Пустой столбец
			//- сохраняет свой flex-basis — всё остаётся на местах.
			//- (v-ads переиспользуется на странице оплаты БЕЗ header — там лишних
			//- пустых столбцов не появится.)
			.advrtsmnt__top-wrap-info.advrtsmnt__top-wrap-info--detail(v-if="data.header && data.header.detail")
				.advrtsmnt__header-detail(v-if="showHeaders") {{data.header.detail}}
				.advrtsmnt__top-info
					.advrtsmnt__top-detail(v-if="data.detail" v-html="data.detail" )
			.advrtsmnt__top-wrap-info.advrtsmnt__top-wrap-info--renewal(v-if="data.header && data.header.time")
				.advrtsmnt__header-time(v-if="showHeaders") {{data.header.time}}
				.advrtsmnt__top-info
					.advrtsmnt__top-renewal(v-if="data.renewal")
						span.advrtsmnt__top-renewal-time(v-if="data.renewal.time") {{ data.renewal.time }}
						span.advrtsmnt__top-renewal-date(v-if="data.renewal.date") ,&nbsp;{{ data.renewal.date }}
			.advrtsmnt__top-wrap-info.advrtsmnt__top-wrap-info--date
				.advrtsmnt__header-date(v-if="showHeaders && data.header && data.header.date") {{data.header.date}}
				.advrtsmnt__top-info
					.advrtsmnt__top-dates(v-if="data.date")
						.advrtsmnt__top-date
							.advrtsmnt__top-date-wrap
								.advrtsmnt__top-date-text(v-if="data.date.text") {{data.date.text}}
						.advrtsmnt__top-status(v-if="data.status && data.status.text" :class="data.status?.className") {{ data.status.text }}
					.advrtsmnt__top-dates(v-if="data.dateBottom")
						.advrtsmnt__top-date
							.advrtsmnt__top-date-wrap
								.advrtsmnt__top-date-text(v-if="data.dateBottom.text") {{data.dateBottom.text}}
						.advrtsmnt__top-status(v-if="data.statusBottom && data.statusBottom.text" :class="data.statusBottom?.className") {{ data.statusBottom.text }}
					.advrtsmnt__top-owner(v-if="data.owner" ) {{ data.owner }}
			.advrtsmnt__top-wrap-type
				.advrtsmnt__header-status(v-if="showHeaders && data.header && data.header.status") {{data.header.status}}
				.advrtsmnt__top-type
					.advrtsmnt__top-type-row(v-if="data.type && data.type.text")
						.advrtsmnt__top-type-value(:style="{backgroundColor: data.type?.background || '#42948E', color: data.type?.color || '#FFF'}") {{data.type.text}}
					.advrtsmnt__top-type-row(v-if="data.typeBottom && data.typeBottom.text")
						.advrtsmnt__top-type-value(:style="{backgroundColor: data.typeBottom?.background || '#42948E', color: data.typeBottom?.color || '#FFF'}") {{data.typeBottom.text}}
			.advrtsmnt__top-wrap-settings
				.advrtsmnt__header-settings(v-if="showHeaders && data.header && data.header.settings") {{data.header.settings}}
				.advrtsmnt__top-settings(v-if="data.buttons")
					button.advrtsmnt__top-button(v-for="(button, index) in data.buttons"
						:key="index"
						@click="isActionsOpen = !isActionsOpen")
						v-svg-icon.advrtsmnt__top-button-icon(v-if="button.icon"
							:icon="button.icon"
							:class="{'rotate-180' : isActionsOpen}")
			.advrtsmnt__top-cost(v-if="data.fullPrice")
				.advrtsmnt__top-cost-title(v-if="data.fullPrice.text" ) {{ data.fullPrice.text }}:
				template(v-if="data.fullPrice.current")
					span.advrtsmnt__top-cost-current-currency(v-if="data.fullPrice.current.currency") {{data.fullPrice.current.currency}}&nbsp
					span.advrtsmnt__top-cost-current-value(v-if="data.fullPrice.current.value != null") {{formatInteger(data.fullPrice.current.value)}}
			//.ads__top-month(v-if="data.term")
			//	.ads__top-label(v-if="isXs && data.term.label") {{data.term.label}}
			//	.ads__top-month-value(v-if="data.term.text") {{data.term.text}}
		transition(name="collapse")
			.advrtsmnt__bottom(v-if="isActionsOpen" )
				ul.advrtsmnt__links
					template(v-for="({action, text, href, icon}, ind) in data.actions" :key="ind" )
						li.advrtsmnt__links-item
							template(v-if="href")
								a.advrtsmnt__links-item-btn(v-if="text" :href="href" @click="$emit('navigate')")
									v-svg-icon.advrtsmnt__links-item-btn-icon(:icon="icon")
									| {{text}}
							template(v-else)
								button.advrtsmnt__links-item-btn(v-if="text" @click="handleClick(action)" :class="{'remove': action === 'remove'}")
									v-svg-icon.advrtsmnt__links-item-btn-icon(:icon="icon")
									| {{text}}

</template>


<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';

export default {
	emits: [
		'action',
		'navigate',
	],
	props: {
		// В таблице ЛК на ПК заголовки вынесены в общую строку. На мобильных и
		// в остальных местах использования карточки подписи остаются внутри неё.
		showHeaders: {
			type: Boolean,
			default: true
		}
	},
	mixins: [
		sourceMixin,
		isMobMixin,
		formattingMixin
	],
	data() {
		return {
			data: null,
			isActionsOpen: false
		}
	},
	computed: {
		// «Регион, Район» под ID в столбце «Информация». Район без региона и регион
		// без района тоже выводим — лишней запятой не будет.
		locationText() {
			const location = this.data?.location;

			if (!location) {
				return '';
			}

			return [location.region, location.district].filter(Boolean).join(', ');
		}
	},
	methods: {

		dataSet(data) {
			this.data = data;
		},

		handleClick(action) {
			this.$emit('action', {action, id: this.data.id});
		}
	},

}
</script>
